import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPostBuildings_buildingIdHeatingSync = z.any()
export type TagsPostBuildings_buildingIdHeatingSync = z.infer<typeof tagsPostBuildings_buildingIdHeatingSync>

export const paramsPostBuildings_buildingIdHeatingSync = z.object({ "buildingId": z.string().uuid() })
export type ParamsPostBuildings_buildingIdHeatingSync = z.infer<typeof paramsPostBuildings_buildingIdHeatingSync>

export const bodyPostBuildings_buildingIdHeatingSync = z.object({ "year": z.number().gte(1775).lte(9999) }).strict()
export type BodyPostBuildings_buildingIdHeatingSync = z.infer<typeof bodyPostBuildings_buildingIdHeatingSync>

export const responsePostBuildings_buildingIdHeatingSync = z.object({ "payload": z.object({ "started": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponsePostBuildings_buildingIdHeatingSync = z.infer<typeof responsePostBuildings_buildingIdHeatingSync>

interface IPostBuildings_buildingIdHeatingSync extends BaseMethodType {
  tags: TagsPostBuildings_buildingIdHeatingSync,
  params: ParamsPostBuildings_buildingIdHeatingSync,
  body: BodyPostBuildings_buildingIdHeatingSync,
  response: ResponsePostBuildings_buildingIdHeatingSync
}
export const URL = '/buildings/:buildingId/heating/sync'
export const validation = {
  post: {
    tags: tagsPostBuildings_buildingIdHeatingSync,
    params: paramsPostBuildings_buildingIdHeatingSync,
    body: bodyPostBuildings_buildingIdHeatingSync,
    response: responsePostBuildings_buildingIdHeatingSync
  }
}
export interface Buildings_buildingIdHeatingSync extends BaseRouteType {
  post: IPostBuildings_buildingIdHeatingSync
}